import React from "react";

import "./home.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

function HomeScreen() {
  const fileInputRef = React.useRef<HTMLInputElement | null>(null);
  const [uploadedVideoData, setUploadedVideoData] = React.useState<any>(null);
  const [fileData, setFileData] = React.useState<any>(null);

  const handleDivClick = () => {
    if (fileInputRef?.current === null) return;
    fileInputRef?.current.click(); // open file picker
  };

  const handleFileChange = (e: any) => {
    const file = e.target.files[0];
    if (file) {
      console.log("Selected file:", file.name);
      setFileData(file);
    }
  };

  const uploadVideoFile = () => {
    setUploadedVideoData({
      videoUri: "https://example.com/video.mp4",
      data: {
        ai_summary:
          "Player shows good footwork but needs improvement in smash power...",
        detected_errors: [
          {
            detail: "Low wrist speed detected",
            recommendation: "Practice wrist snap drills",
            severity: "medium",
            type: "weak_smash",
          },
        ],
        features: {
          avg_knee_angle: 90,
          avg_shoulder_angle: 45,
          avg_wrist_speed: 2.5,
          contact_events: [
            {
              frame: 50,
              type: "smash",
            },
          ],
          frames: 300,
          recovery_time: 500,
        },
        performance_score: 75.5,
        player_id: "PLR001",
        recommendations: [
          "Shadow swing drills",
          "Ladder footwork training",
          "Wrist strength exercises",
        ],
        session_id: "SESSION_001",
        timestamp: "2024-01-15T10:30:00",
      },
    });
  };

  return (
    <>
      <Header />
      <div className="admin-home-container">
        <div className="main-container">
          <section className="text-center py-12 bg-gradient-to-r from-blue-100 to-blue-50">
            <h2 className="text-3xl font-bold mb-2 text-gray-800">
              Smart Badminton Video Analyzer
            </h2>
            <p className="text-gray-600">
              Easily upload, preview, and view details of your video collection.
            </p>
            {fileData?.name && (
              <div className="d-flex justify-content-around mt-3">
                <div className="selected-filedetails">
                  <p className="text-gray-600">
                    <strong>Selected File:</strong> {fileData?.name}
                  </p>
                </div>
              </div>
            )}
            {!uploadedVideoData?.data && (
              <div className="d-flex justify-content-around mt-4 mb-4">
                <input
                  type="file"
                  accept="video/*"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  className="d-none"
                />
                {fileData?.name ? (
                  <>
                    <div className="video-uploader" onClick={uploadVideoFile}>
                      Upload Video
                    </div>
                  </>
                ) : (
                  <div className="video-uploader" onClick={handleDivClick}>
                    Select Video
                  </div>
                )}
              </div>
            )}
          </section>
          {uploadedVideoData?.data && (
            <div className="row mt-3">
              <div className="col-12">
                <h5>Video Details</h5>
                <div className="row">
                  <div className="col-4">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">Player ID:</h5>
                        <h6 className="card-subtitle mb-2 text-muted">
                          {uploadedVideoData?.data?.player_id}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">Performance score:</h5>
                        <h6 className="card-subtitle mb-2 text-muted">
                          {uploadedVideoData?.data?.performance_score}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header">Detected Errors:</div>
                      <div className="card-body">
                        {uploadedVideoData?.data?.detected_errors?.length >
                        0 ? (
                          <div>
                            <p>
                              <strong>Type:</strong>&nbsp;
                              {uploadedVideoData.data.detected_errors[0].type}
                            </p>
                            <p>
                              <strong>Detail:</strong>&nbsp;
                              {uploadedVideoData.data.detected_errors[0].detail}
                            </p>
                            <p>
                              <strong>Recommendation:</strong>
                              &nbsp;
                              {
                                uploadedVideoData.data.detected_errors[0]
                                  .recommendation
                              }
                            </p>
                            <p>
                              <strong>Severity:</strong>&nbsp;
                              {
                                uploadedVideoData.data.detected_errors[0]
                                  .severity
                              }
                            </p>
                          </div>
                        ) : (
                          <p>No errors found</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header">
                        Improvement Recommendations:
                      </div>
                      <div className="card-body">
                        {uploadedVideoData?.data?.recommendations?.length >
                        0 ? (
                          <>
                            {uploadedVideoData.data.recommendations.map(
                              (recommendation: any, index: number) => (
                                <div key={index}>
                                  <p>
                                    <strong>{index + 1}.</strong>{" "}
                                    {recommendation}
                                  </p>
                                </div>
                              )
                            )}
                          </>
                        ) : (
                          <p>Improvement recommendations not found</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default HomeScreen;
